import React from 'react';

import { useAppDispatch, useAppSelector } from 'src/store';
import { createNote } from 'src/thunks/note';
import { Content } from 'src/hooks/useClassTopicContent';
import { TextArea } from 'src/components/coreUI/index';

type Props = {
  content?: Content;
  class_id?: string;
};

const NoteForm: React.FC<Props> = ({ content, class_id }) => {
  const dispatch = useAppDispatch();
  const user_id = useAppSelector((state) => state.ui.app.me?.id);

  return (
    <div className="mt-36">
      <TextArea
        placeholder="Add a note"
        onSend={async (html) => {
          await dispatch(
            createNote({
              class_id,
              user_id,
              class_topic_id: content?.class_topic_id,
              class_topic_content_id: content?.id,
              note: html,
            }),
          );
        }}
      />
    </div>
  );
};

export default NoteForm;
